import { Column } from '@usitsdasdesign/dds-ng/shared';

export const opportunityTableColumns: Column[] = [
  {
    name: 'opportunityNumber',
    header: 'Opportunity ID:',
    dataType: 'string',
    minWidth: '6.25rem',
  },
  {
    name: 'opportunityName',
    header: 'Opportunity name:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'stage',
    header: 'Opportunity Stage:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'client',
    header: 'Client:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'leader',
    header: 'Leader:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'numberOfSplits',
    header: 'Number of splits:',
    dataType: 'number',
    minWidth: '8.75rem',
  },
  {
    name: 'totalGlobalOpportunityAmount',
    header: 'Total global opportunity amount $:',
    dataType: 'string',
    minWidth: '12.25rem',
  },
];

export const engagementTableColumns: Column[] = [
  {
    name: 'submissionID',
    header: 'Submission ID:',
    dataType: 'number',
    minWidth: '6.25rem',
  },
  {
    name: 'jupiterOpportunityID',
    header: 'Opportunity ID:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'submissionTitle',
    header: 'Submission title:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'memberFirm',
    header: 'Member firm:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'responsibleDeliveryCenterPPMD',
    header: 'Responsible Delivery Center PPMD:',
    dataType: 'string',
    minWidth: '12.25rem',
  },
  {
    name: 'offeringPortfolioName',
    header: 'Offering Portfolio:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
  {
    name: 'offeringName',
    header: 'Offering:',
    dataType: 'string',
    minWidth: '8.75rem',
  },
];